import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RecordCustodyParams } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const recordCustody = createAsyncThunk<
  void,
  RecordCustodyParams,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RECORD_CUSTODY, async (params, { extra }) => {
  await extra.batchesRepo.recordCustody(params);
});
